"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.MENU_UNAVAILABLE = exports.LOCATION_NOT_EXIST = exports.ITEM_WAS_ADDED_TEXT = exports.ITEM_UNAVAILABLE = exports.FIND_NEAREST_LOCATION = exports.ADD_TO_CART_BUTTON_TEXT = void 0;
var ITEM_UNAVAILABLE = 'Item Unavailable';
exports.ITEM_UNAVAILABLE = ITEM_UNAVAILABLE;
var ADD_TO_CART_BUTTON_TEXT = 'Add To Cart'; // menuType1 Component

exports.ADD_TO_CART_BUTTON_TEXT = ADD_TO_CART_BUTTON_TEXT;
var ITEM_WAS_ADDED_TEXT = 'was added to your cart';
exports.ITEM_WAS_ADDED_TEXT = ITEM_WAS_ADDED_TEXT;
var LOCATION_NOT_EXIST = 'uh oh! This location doesn\'t exist';
exports.LOCATION_NOT_EXIST = LOCATION_NOT_EXIST;
var FIND_NEAREST_LOCATION = 'Find The Nearest Location';
exports.FIND_NEAREST_LOCATION = FIND_NEAREST_LOCATION;
var MENU_UNAVAILABLE = 'The menu is currently unavailable';
exports.MENU_UNAVAILABLE = MENU_UNAVAILABLE;
var _default = {
  ITEM_UNAVAILABLE: ITEM_UNAVAILABLE,
  ADD_TO_CART_BUTTON_TEXT: ADD_TO_CART_BUTTON_TEXT,
  ITEM_WAS_ADDED_TEXT: ITEM_WAS_ADDED_TEXT,
  LOCATION_NOT_EXIST: LOCATION_NOT_EXIST,
  FIND_NEAREST_LOCATION: FIND_NEAREST_LOCATION,
  MENU_UNAVAILABLE: MENU_UNAVAILABLE
};
exports["default"] = _default;